function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1 20C1 9.5066 9.50659 1 20 1H141.074C151.54 1 160.035 9.45575 160.061 19.9201C160.19 70.0575 160.175 132.555 160.127 179.6C160.103 203.123 160.072 222.782 160.046 235.101C160.042 236.973 160.038 238.675 160.034 240.196C159.678 239.704 159.275 239.238 158.826 238.796C156.773 236.781 153.814 235.336 150.15 234.302C142.835 232.238 132.341 231.716 119.535 231.917C108.902 232.085 96.5877 232.754 83.0521 233.491C80.2579 233.643 77.4117 233.797 74.5175 233.951C57.5913 234.851 38.9986 235.718 19.4872 235.792C9.21853 235.831 1 227.407 1 217.101V20Z",
  stroke: "white",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M321 20C321 9.50661 312.493 1 302 1H180.928C170.461 1 161.967 9.45575 161.94 19.9201C161.812 70.0575 161.827 132.555 161.875 179.6C161.898 203.123 161.93 222.782 161.956 235.101C161.96 236.973 161.964 238.675 161.967 240.195C162.323 239.704 162.727 239.238 163.176 238.796C165.228 236.781 168.188 235.336 171.851 234.302C179.167 232.238 189.66 231.716 202.466 231.917C213.1 232.085 225.414 232.754 238.949 233.491C241.743 233.643 244.589 233.797 247.483 233.951C264.409 234.851 283.002 235.718 302.513 235.792C312.781 235.831 321 227.407 321 217.101V20Z",
  stroke: "white",
  strokeWidth: 2
});

var SvgLogoSharp = function SvgLogoSharp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 322 249",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoSharp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo_sharp.c132fa16.svg";
export { ForwardRef as ReactComponent };